import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import language from './language';

const config = require('../../config.json');

Vue.use(Vuex);

const persistedState = createPersistedState({
  paths: ['language'],
});

function formatVersion(value) {
  return String(value || '').replace(/^v/i, '');
}

function getReleaseTitle(release) {
  if (release.name && release.tag_name && release.name !== release.tag_name) {
    return release.name;
  }

  const bodyLine = release.body?.split('\n').find(line => line.trim());
  return bodyLine || 'Release published';
}

export default new Vuex.Store({
  modules: {
    language,
  },
  plugins: [persistedState],
  state: {
    version: null,
    versionTimestamp: null,
    changeLog: [],
    config: null,
    discordUserCount: null,
  },
  getters: {
    version: state => state.version,
    versionTimestamp: state => state.versionTimestamp,
    changeLog: state => state.changeLog,
    config: state => state.config,
    discordUserCount: state => state.discordUserCount,
  },
  mutations: {
    setVersion(state, version) {
      state.version = version;
    },
    setVersionTimestamp(state, versionTimestamp) {
      state.versionTimestamp = versionTimestamp;
    },
    setChangeLog(state, changeLog) {
      state.changeLog = changeLog;
    },
    setConfig(state, configData) {
      state.config = configData;
    },
    setDiscordUserCount(state, discordUserCount) {
      state.discordUserCount = discordUserCount;
    },
  },
  actions: {
    async getAppData({ commit, dispatch }) {
      commit('setConfig', config);

      try {
        const { data: appData } = await axios.get(`${config.api_url}/data/all`);
        const changeLog = (appData.changelog?.releases || [])
          .filter(release => !release.draft)
          .slice(0, 5)
          .map(release => ({
            id: release.id,
            version: formatVersion(release.tag_name || release.name),
            title: getReleaseTitle(release),
            url: release.html_url,
            timestamp: Date.parse(release.published_at || release.created_at),
          }));

        commit('setChangeLog', changeLog);
        commit('setVersion', changeLog[0]?.version || null);
        commit('setVersionTimestamp', changeLog[0]?.timestamp || null);
        commit('setDiscordUserCount', appData.discordUserCount);
      } catch (error) {
        console.error('Error getting data, trying again in 10 seconds...');
        setTimeout(async () => {
          await dispatch('getAppData');
        }, 10000);
      }
    },
  },
});
